<template>
    <b-container>
        <b-card class="mt-3">
            <b-row>
                <b-col>
                <b-form-group
                 id="import-state"
                 label="Contact Import State"
                 label-for="import-state"
                 description="Processing state to filter">
                 <b-form-select id="import-state" v-model="importState" :options="importStates" @change="refresImportContactList()"></b-form-select>
                </b-form-group>                
                </b-col>
            </b-row>            
            <b-row>
            <b-table
                :fields="table.fields"
                :items="table.items"
                class="mb-3 mt-3"
                striped
                responsive
                show-empty
                empty-text="No Contacts to Import"
                outlined>
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(full_name)="row">
                    {{row.item.first_name}} {{row.item.last_name}}
                </template>
                <template #cell(show_details)="row">
                  <b-button size="sm" @click="row.toggleDetails" class="mr-2" v-if="row.item.import_message !==null">
                    {{ row.detailsShowing ? 'Hide' : 'Show'}}
                  </b-button>                  
                </template>                
                <template #row-details="row">
                  <b-card>
                      {{row.item.import_message}}
                  </b-card>
                </template>
                <template #cell(import_status)="row">
                    <b-badge :variant="chooseColor(row.item.import_status)">{{row.item.import_status}}</b-badge>
                </template>                                   
            </b-table>
            </b-row>
        <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchImportContacts(currentPage-1)">Prev</b-button>
                    <b-button @click="searchImportContacts(currentPage+1)">Next</b-button>
                </b-button-group>                
            </b-col>                
        </b-row>
        </b-card>        
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import handleError from "@/errorHandler";
export default {
    name: "WardImportRequestContacts",
    props: {
        importRequestId: {
            type: String,
            required: false
        }
    },
    data () {
        return {
            state_colors: {
                'PENDING': 'secondary',
                'PROCESSING': 'warning',
                'FINISHED': 'success',
                'FAILED': 'danger'
            },
            importStates: [],
            importState: 'PENDING',
            ward: {
                ward_name: null
            },
            pages: [],
            nextPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },               
            table: {
                id: "bulk-import-contact-list",
                fields: [
                    {
                        key: 'full_name',
                        label: 'Full Name'
                    },
                    {
                        key: 'phone_number',
                        label: 'Phone Number'

                    },
                    {
                        key: 'import_status',
                        label: 'Import Status'
                    },
                    {
                        key: 'primary_organization',
                        label: 'Primary Organization'
                    },
                    {
                        key: 'aux_organization',
                        label: 'Auxilary Organizations'
                    },
                    {
                        key: 'show_details',
                        label: 'View Errors'
                    }
                ],
                items: [],
                isBusy: false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }
            }            

        }
    },
    async mounted() {
        this.importStates = this.$store.state.frontEndSettings.import_states;
        this.pages.push(this.nextPage);
        await this.searchImportContacts(0);          

    },
    methods: {
        chooseColor(theStatus) {
            return this.state_colors[theStatus];
        },
        async searchImportContacts(page) {
            if(page < 0) {
                return;
            }
            if(page > this.pages.length - 1) {
                return;
            }
            const payload =  this.pages[page];
            payload.import_state = this.importState;
            this.table.isBusy = true;
            try {
                const { data } = await WardApi.searchImportRequestsContacts(this.wardId, this.importRequestId, payload);
                if (data.last_evaluated_key !== null) {
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key); 
                }
                this.table.items = data.contact_list;
                this.table.isBusy = false;
                this.currentPage = page;
            } catch (e) {
                handleError(e, "Failed to fetch contact list");
            }
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;
        },
        async refresImportContactList() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchImportContacts(0);
        },      
    }
}
</script>

